// src/guides/GuideAvailability.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const GuideAvailability = () => {
    const { fetchWithAuth, user, loggedIn, loading: authLoading } = useAuth();
    const [availableDates, setAvailableDates] = useState([]);
    const [newDate, setNewDate] = useState("");
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL;

    // Load availability once user is ready
    useEffect(() => {
        if (!loggedIn || authLoading || !user?.email) return;

        const fetchAvailability = async () => {
            try {
                const res = await fetchWithAuth(
                    `${API_URL}/availability?guideEmail=${encodeURIComponent(user.email)}`
                );
                const data = await res.json();
                setAvailableDates(data.availableDates || []);
            } catch (err) {
                console.error("Error fetching availability:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchAvailability();
    }, [user, loggedIn, authLoading, fetchWithAuth, API_URL]);

    // Add new date
    const addDate = async () => {
        if (!newDate) return alert("Pick a date first");
        try {
            const res = await fetchWithAuth(`${API_URL}/availability`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ guideEmail: user.email, dates: [newDate] }),
            });
            const data = await res.json();
            setAvailableDates(data.availableDates || []);
            setNewDate("");
        } catch (err) {
            console.error("Error adding availability:", err);
        }
    };

    // Remove a date
    const removeDate = async (date) => {
        try {
            const res = await fetchWithAuth(`${API_URL}/availability`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ guideEmail: user.email, date }),
            });
            const data = await res.json();
            setAvailableDates(data.availableDates || []);
        } catch (err) {
            console.error("Error removing availability:", err);
        }
    };

    if (authLoading || loading) return <p className="guide-availability-loading">Loading availability...</p>;

    if (!loggedIn) return <p>Please login to view your availability.</p>;

    return (
        <div className="guide-availability-dashboard">
            <h3 className="guide-availability-heading">📍 Availability</h3>

            <div className="guide-availability-input">
                <input
                    className="guide-availability-date-input"
                    type="date"
                    value={newDate}
                    onChange={(e) => setNewDate(e.target.value)}
                />
                <button
                    className="guide-availability-add-btn"
                    onClick={addDate}
                >
                    Add Date
                </button>
            </div>

            {availableDates.length === 0 ? (
                <p className="guide-availability-empty">No dates set yet.</p>
            ) : (
                <ul className="guide-availability-list">
                    {availableDates.map((d) => (
                        <li className="guide-availability-item" key={d}>
                            <span className="guide-availability-date">
                                {new Date(d).toLocaleDateString()}
                            </span>{" "}
                            <button
                                className="guide-availability-remove-btn"
                                onClick={() => removeDate(d)}
                            >
                                ❌ Remove
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default GuideAvailability;
